var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankTymeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6226 0L0.40625 3.56649V6.44341L16.1587 3.69648L25.2247 7.08775V4.97386L17.6226 0Z",
    fill: "url(#paint0_linear_510_104242)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.40625 7.51792V10.5079L13.9826 9.36051L25.2247 10.5983V7.95313L15.6104 5.18359L0.40625 7.51792Z",
    fill: "url(#paint1_linear_510_104242)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.40625 11.4852V14.5486L11.4392 15.323L25.2247 14.6391V11.5191L13.3496 10.7617L0.40625 11.4852Z",
    fill: "url(#paint2_linear_510_104242)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.40625 18.0085L9.24051 20.8741L25.2247 18.6076V15.5837L10.8174 16.6972L0.40625 15.4707V18.0085Z",
    fill: "url(#paint3_linear_510_104242)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.40625 20.9077L7.21705 26.0003L25.2247 22.626V19.7151L8.65269 22.3603L0.40625 18.9238V20.9077Z",
    fill: "url(#paint4_linear_510_104242)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_510_104242",
    x1: 24.5747,
    y1: 8.88513,
    x2: 1.52537,
    y2: 0.491733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFC425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#AA8E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#6F6854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_510_104242",
    x1: 24.213,
    y1: 13.3792,
    x2: 1.30493,
    y2: 5.04229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFC425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#AA8E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#6F6854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_510_104242",
    x1: 24.2921,
    y1: 17.2108,
    x2: 1.36146,
    y2: 8.86261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFC425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#AA8E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#6F6854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_510_104242",
    x1: 24.3543,
    y1: 20.9985,
    x2: 1.42928,
    y2: 12.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFC425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#AA8E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#6F6854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_510_104242",
    x1: 24.0999,
    y1: 25.7233,
    x2: 0.994069,
    y2: 17.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFC425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#AA8E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#6F6854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTymeIcon);
export default __webpack_public_path__ + "static/media/bank-tyme-icon.c258e2045a52c87f7192c0e62a2a4022.svg";
export { ForwardRef as ReactComponent };